import { useMemo } from 'react';
import Link from 'next/link';
import { topNewsQueryParams } from '@/constants/queryParams/newsQueryParams';

import { useEntityData } from '@/hooks/useEntityData';

export default function NewsTopSearch() {
  const queryParams = useMemo(() => topNewsQueryParams, []);
  const { data: topNewsData }: any = useEntityData('news-and-blogs', queryParams);

  return (
    topNewsData?.data?.results?.length > 0 && (
      <div className="mx-auto flex w-[95%] max-w-screen-xl items-center gap-x-2 py-0.5 md:gap-x-4">
        <div className="text-nowrap text-sm font-medium lg:text-lg">Trending Searches:</div>
        <div className="hide-scrollbar mx-auto flex w-full gap-2 overflow-x-auto md:gap-2.5">
          {topNewsData?.data?.results?.map((item: any) => {
            return (
              <Link
                key={item.id}
                href={`/news/${item?.url}`}
                className="z-20 block w-full min-w-fit truncate rounded-full border border-blue-400 bg-sky-100 px-2 py-1 font-poppins text-xs text-primary-text sm:px-4 sm:py-1.5 sm:text-sm"
              >
                {item?.name?.slice(0, 35) ?? ''}
                {item?.name?.length > 35 && '...'}
              </Link>
            );
          })}
        </div>
      </div>
    )
  );
}
